import type { FaireProductEntity } from "../../entity_types/product";

export const p_vx3uhppt3k: FaireProductEntity = {
  token: "p_vx3uhppt3k",
  type: "product",
  name: "Heather Ceramic Bud Vase",
  brandName: "Danica Heirloom",
  imageUrl:
    "https://cdn.faire.com/fastly/0a4e747366e01b1364ba0038a12011bc50b3cb0f1aaad49450551b22f970c111.jpeg",
  priceDollars: 6.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/9fa1249b3d5d74ffd5b87c2abfc8d5e710276d0bd172110f89a977eb08aa35f7.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
